import Axios from "axios";
import { globalData } from "@/main";
import AppConfig from "@/config/AppConfig";

export default {
  pending(any, apsId) {
    const params = {
      apsId: apsId,
      any: any
    }
    return Axios.get(
      "/bonusProduction/pending", {
        params: params
      }
    );
  },
  pendingPdf(apsUserName, apsId, agencyName) {
    const params = {
      apsUserName: apsUserName,
      apsId: apsId,
      agencyName: agencyName
    }
    return Axios.get(
      "/bonusProduction/pendingPdf", {
        responseType: 'arraybuffer',
        params: params
      }
    );
  },
  pendingExcel(apsUserName, apsId, agencyName) {
    const params = {
      apsUserName: apsUserName,
      apsId: apsId,
      agencyName: agencyName
    }
    return Axios.get(
      "/bonusProduction/pendingExcel", {
        responseType: 'arraybuffer',
        params: params
      }
    );
  },
  preliquidationGeneration(data, apsRuc, apsId, agencyName) {
    const params = {
      agencyName: agencyName,
      apsId: apsId,
      apsRuc: apsRuc,
    }

    if(!globalData.validaSucursal ){
            params.agencyId = 0;
          }
    return Axios.post(
      "/bonusProduction/preliquidationGeneration",
      data, {
        params: params
      }
    );
  },
  validatePermission(apsRuc) {
    const params = {
      apsRuc: apsRuc,
    }
    return Axios.get(
      "/bonusProduction/validatePermission", {
        params: params
      }
    );
  },
  preliquidationApprove(data, apsId, agencyName) {
    const params = {
      agencyName: agencyName,
      apsId: apsId
    }
    return Axios.post(
      "/bonusProduction/preliquidationApprove", {
        preliquidationsId: data
      }, {
        params: params
      }
    );
  },
  preliquidationApproveAndBill(data, apsId, agencyName) {
    const params = {
      agencyName: agencyName,
      apsId: apsId
    }
    return Axios.post(
      "/bonusProduction/preliquidationApproveAndBill", {
        preliquidationsId: data
      }, {
        params: params
      }
    );
  },
  preliquidationReject(data,apsId, agencyName) {
    const params = {
      agencyName: agencyName,
      apsId: apsId,
    }
    return Axios.post(
      "/bonusProduction/preliquidationReject", {
        preliquidationsId: data
      }, {
        params: params
      }
    );
  },
  preliquidation(any, apsId, agencyName) {
    const params = {
      apsId: apsId,
      agencyName: agencyName,
      any: any
    }
    return Axios.get(
      "/bonusProduction/preliquidation", {
        params: params
      }
    );
  },
  liquidation(any, apsId) {
    const params = {
      apsId: apsId,
      any: any
    }
    return Axios.get(
      "/bonusProduction/liquidation", {
        params: params
      }
    );
  },
  bonusProductionPdf(id) {
    const params = {
      id: id
    }
    return Axios.get(
      "/bonusProduction/bonusProductionPdf", {
        responseType: 'arraybuffer',
        params: params
      }
    );
  },
  bonusPreliminarProductionPdf(id) {
    const params = {
      id: id
    }
    return Axios.get(
      "/bonusProduction/bonusProductionPreliminarPdf", {
        responseType: 'arraybuffer',
        params: params
      }
    );
  },
  bonusProductionExcel(id) {
    const params = {
      id: id
    }
    return Axios.get(
      "/bonusProduction/bonusProductionExcel", {
        responseType: 'arraybuffer',
        params: params
      }
    );
  },
  IsUserAgent(userId) {
    return Axios.get(AppConfig.siaerpBaseUrl + `Siaerp/GetAgenteById?idUsuario=${userId}`);
  },
};